import axios from 'axios'
import {
 ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_REQUEST,
 ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_SUCCESS,
 ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_FAIL,
 ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_RESET,
 GET_VERIFICATION_PROCESS_ASSIGNMENTS_REQUEST,
 GET_VERIFICATION_PROCESS_ASSIGNMENTS_SUCCESS,
 GET_VERIFICATION_PROCESS_ASSIGNMENTS_FAIL,
 GET_VERIFICATION_PROCESS_ASSIGNMENTS_RESET,
 UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
 UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
 UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
 UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_RESET,
 DELETE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
 DELETE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
 DELETE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
 DELETE_VERIFICATION_PROCESS_ASSIGNMENT_RESET,
} from '../constants/verificationAssignProcessConstant';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const assignVerificationProcessesToProcessManager = (processManagerId, verificationProcessIds) => async (dispatch, getState) => {
 try {
   dispatch({
     type: ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.post(
     `${baseUrl}/assignVerificationProcess/assign`,
     { processManagerId, verificationProcessIds },
     config
   );

   dispatch({
     type: ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const getVerificationProcessAssignments = (queryParams) => async (dispatch, getState) => {
 try {
   dispatch({
     type: GET_VERIFICATION_PROCESS_ASSIGNMENTS_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.get(
     `${baseUrl}/assignVerificationProcess${queryParams ? `?${queryParams}` : ''}`,
     config
   );

   dispatch({
     type: GET_VERIFICATION_PROCESS_ASSIGNMENTS_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: GET_VERIFICATION_PROCESS_ASSIGNMENTS_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const updateVerificationProcessAssignment = (id, verificationProcessIds) => async (dispatch, getState) => {
 try {
   dispatch({
     type: UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.put(
     `${baseUrl}/assignVerificationProcess/${id}`,
     { verificationProcessIds },
     config
   );

   dispatch({
     type: UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};

export const deleteVerificationProcessAssignment = (id) => async (dispatch, getState) => {
 try {
   dispatch({
     type: DELETE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
   });

   const {
     userLogin: { userInfo },
   } = getState();

   const config = {
     headers: {
       'Content-Type': 'application/json',
       Authorization: `Bearer ${userInfo.token}`,
     },
   };

   const { data } = await axios.delete(
     `${baseUrl}/assignVerificationProcess/${id}`,
     config
   );

   dispatch({
     type: DELETE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
     payload: data,
   });
 } catch (error) {
   if (error.response?.status === 401) {
     dispatch(logout());
     return;
   }
   dispatch({
     type: DELETE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
     payload:
       error.response && error.response.data.message
         ? error.response.data.message
         : error.message,
   });
 }
};